<template>
    <div>
        <!-- Show text styling options when there is a textAttribute or when
            textAttribute should not be shown because there is an advanced label -->
        <!--Tekst vulkleur-->
        <div class="form-inline style-item mt-2">
            <label :for="`textFillColorInput${name}`"
                    class="custom style-label-md text-attribute">{{ $t('labelTextFillColor') }}</label>
            <div class="form-group">
                <div class="input-group">
                    <color-picker :id="`textColorPickerInput${name}`"
                                    name="`textColorPickerInput${name}`"
                                    v-model="textFillColor"></color-picker>
                </div>
            </div>
        </div>
        <!--Tekst lijnkleur-->
        <div class="form-inline style-item">
            <label :for="`textStrokeColorInput${name}`"
                    class="custom style-label-md text-attribute">{{ $t('labelTextLineColor') }}</label>
            <div class="form-group">
                <div class="input-group">
                    <color-picker :id="`textStrokeColorInput${name}`"
                                    name="`textStrokeColorInput${name}`"
                                    v-model="textStrokeColor"></color-picker>
                </div>
            </div>
        </div>
        <!--Tekst lijndikte-->
        <div class="form-inline style-item">
            <div class="form-group">
                <label :for="`textStrokeWidthsl${name}`"
                        class="custom style-label-md text-attribute">{{ $t('labelTextLineWidth') }}</label>
                <b-form-select :id="`textStrokeWidthsl${name}`"
                                class="form-control input-sm"
                                v-model="localThemeStyle.textStrokeWidthDefault"
                                :options="
                        $_convertToValueTextPair(
                            this.layerStyleConst.stroke_width
                        )
                    ">
                    <template v-slot:first>
                        <option :value="null">
                            {{ $t('selectBoxMakeChoice') }}
                        </option>
                    </template>
                </b-form-select>
            </div>
        </div>
        <!--Tekst font-->
        <div class="form-inline style-item">
            <div class="form-group">
                <label for="`textFontsl${name}`"
                        class="custom style-label-md text-attribute">{{ $t('labelFont') }}</label>
                <b-form-select :id="`textFontsl${name}`"
                                class="form-control input-sm"
                                v-model="localThemeStyle.textFontDefault"
                                :options="
                        $_convertToValueTextPair(
                            this.layerStyleConst.font_faces
                        )
                    ">
                </b-form-select>
            </div>
        </div>
        <!--Tekst font size-->
        <div class="form-inline style-item">
            <div class="form-group">
                <label for="`textFontSizesl${name}`"
                        class="custom style-label-md text-attribute">{{ $t('labelFontSize') }}</label>
                <b-form-select :id="`textFontSizesl${name}`"
                                class="form-control input-sm"
                                v-model="localThemeStyle.textFontSizeDefault"
                                :options="
                        $_convertToValueTextPair(
                            this.layerStyleConst.font_sizes
                        )
                    ">
                </b-form-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { convertToValueTextPair } from '../../../services/utilities';
    import { LAYER_STYLE } from '../../../constants';
    import ColorPicker from '../../../components/ColorPicker.vue';

    export default {
        components: {
            'color-picker': ColorPicker
        },
        props: {
            themeStyle: { type: Object, required: true },
            name: { type: String, required: false, default: '' },
        },
        data() {
            return {
                localThemeStyle: this.themeStyle,
                updateFillColor: true,
                updateStrokeColor: true,
                layerStyleConst: LAYER_STYLE
            };
        },
        computed: {
            textStrokeColor: {
                get() {
                    return this.localThemeStyle.textStrokeColorDefault;
                },
                set(input) {
                    this.localThemeStyle.textStrokeColorDefault = input;
                }
            },
            textFillColor: {
                get() {
                    return this.localThemeStyle.textFillColorDefault;
                },
                set(input) {
                    this.localThemeStyle.textFillColorDefault = input;
                }
            }
        },

        methods: {
            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            },
            onUpdated() {
                // This way the two color-pickers are updated
                this.updateFillColor = false;
                this.updateStrokeColor = false;

                // Wait for the change to get flushed
                this.$nextTick(() => {
                    this.updateFillColor = true;
                    this.updateStrokeColor = true;
                });
            }
        },
        watch: {
            themeStyle: {
                handler: function (newVal) {
                    this.onUpdated();
                },
                deep: true,
                immediate: true
            },
        }
    };
</script>
